import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  AircraftProfileEngineAudit,
  EngineAudit
} from '../../+models/aircraft-profile-audit.model';

@Component({
  selector: 'sd-portal-engine-audit-list',
  templateUrl: './engine-audit-list.component.html',
  styleUrls: ['./engine-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EngineAuditListComponent implements OnInit {
  @Input() aircraftProfileEngineId: number;
  @Input() engineId: number;
  @Input() loading: boolean;
  @Input() aircraftProfileEngineAudits: AircraftProfileEngineAudit[];
  @Input() engineAudits: EngineAudit[];

  @Output() loadEngine = new EventEmitter<{ aircraftProfileEngineId: number; engineId: number }>();

  @Output() nextPage = new EventEmitter<{ aircraftProfileEngineId: number; engineId: number }>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadEngine.emit({
      aircraftProfileEngineId: this.aircraftProfileEngineId,
      engineId: this.engineId
    });
  }

  onNextPage() {
    this.nextPage.emit({
      aircraftProfileEngineId: this.aircraftProfileEngineId,
      engineId: this.engineId
    });
  }
}
